import { render } from "./more.vue?vue&type=template&id=3aa9d5ca&scoped=true"
import script from "./more.vue?vue&type=script&lang=js"
export * from "./more.vue?vue&type=script&lang=js"

import "./more.vue?vue&type=style&index=0&id=3aa9d5ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa9d5ca"]])

export default __exports__